import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";

export interface IMembershipArgs extends IAccountObjectArgs {
    user: string;
    accessGroups?: Array<string>;
    contactTypes?: Array<string>;
    lookupTypes?: Array<string>;
    jobTypes?: Array<string>;
    jobStatuses?: Array<string>;
    taskTypes?: Array<string>;
    admin?: boolean;
}

const defaults = {
    user: "",
    accessGroups: [],
    contactTypes: [],
    lookupTypes: [],
    jobTypes: [],
    jobStatuses: [],
    taskTypes: [],
    admin: false
} as IMembershipArgs;

export class Membership extends AccountObject {
    user: string;
    accessGroups: Array<string>;
    contactTypes: Array<string>;
    lookupTypes: Array<string>;
    jobTypes: Array<string>;
    jobStatuses: Array<string>;
    taskTypes?: Array<string>;
    admin: boolean;

    constructor(data?: IMembershipArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/membership/membership.model.ts